/*
 * Copyright (c) 2020.
 * Ducnq
 */

import {SERVER_API_FB_BOT} from '../../constans';
import {headers} from '../../utils';
import {RSAA} from 'redux-api-middleware';
import queryString from 'query-string';
import {REPORT_COLLAB_REQUEST, REPORT_COLLAB_SUCCESS, REPORT_COLLAB_FAILURE} from "../../types";

const ReportCollaboratorsAction = (params = [], userId ) => ({

    [RSAA]: {
        endpoint: () => {
            let queryParam = queryString.stringify(params);

            return `${SERVER_API_FB_BOT}/api/ctv-report/${userId}?${queryParam}`
        },
        method: 'GET',
        headers: (headers()),
        types: [
            REPORT_COLLAB_REQUEST,
            {
                type: REPORT_COLLAB_SUCCESS,
                payload: async (action, state, res) => {
                    let data = [];
                    await res.json().then((json) => {
                        data = json.data
                    });

                    return {
                        "code": 0,
                        "type": REPORT_COLLAB_SUCCESS,
                        "data": data,
                    }
                },
            },
            {
                type: REPORT_COLLAB_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": REPORT_COLLAB_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }
});

export {ReportCollaboratorsAction}